import React, { Fragment } from 'react';
import Navbar from './Navbar';
import Home from './Home';
import About from './About';
import Contact from './Contact';
import Briefcase from './Briefcase';
const Landing = ({ data }) => {
  return (
    <Fragment>
      <Navbar></Navbar>
      <div className="container">



        <Home></Home>
      </div>
      <About></About>
      <Briefcase data={data}></Briefcase>
      <div className="container-fluid">
        <Contact></Contact>
      </div>
    </Fragment>
  );
}

export default Landing;
